import React from 'react';
import PropTypes from 'prop-types';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMOReservationDialogHeaderView from './SMOReservationDialogHeaderView';

class SMOReservationConfirmView extends React.Component {
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }
  
  formDidSubmit(e){
    e.preventDefault();
    this.trackPageEvent('od sumit confirm_reservation');
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMOwnerResource.confirm(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.reservationDidConfirm === 'function'){
          this.props.delegate.reservationDidConfirm(data, xhr);
        }
      } else {
        if(this.props.delegate && typeof this.props.delegate.reservationDidFailToConfirm === 'function'){
          this.props.delegate.reservationDidFailToConfirm(error, xhr);
        }
      }
    });
  }
  
  render() {
    let reservation = this.props.reservation;
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <SMOReservationDialogHeaderView />
        <h2 className="dashboard-title mb30 ta-c" 
          dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000027")}} />
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <div className="form-box">
            <h3 className="dashboard-title mb20">
              <span className="icon-form icon-form__optional">{I18n.t("dashboard.label_000060")}</span>
              {I18n.t("dashboard.label_000011")}
              <span className="dashboard-title__supplement ml15">400字以内</span>
            </h3>
            <textarea name="content" className="w700 h80" placeholder="予約リクエストありがとうございます。利用用途等問題ありません。承認させて頂きます。"></textarea>
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton 
              title={I18n.t("dashboard.label_000109")} 
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}
SMOReservationConfirmView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMOReservationConfirmView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationConfirmView.jsx